<template>
  <!-- ,"supplier": {"code": 1} -->
  <div class="basket-page">
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.cart.cart') }}
      </h1>
    </div>
    <main class="basket-page__main">
      <div
        v-for="(supplierPositions, supplier) in positionsBySupplier"
        :key="supplier + 'item'"
      >
        <div
          :key="supplier + 'parts'"
          class="mb-8"
        >
          <div
            v-if="workMode.isModeSollers"
            class="basket-page__supplier"
          >
            {{ supplier ? `${$t('common.supplier')}: ${supplier}` : `${$t('common.order_type')}: ${$t('common.order_type_regular')}` }}
          </div>
          <v-data-table
            fixed-header
            :headers="headers"
            :items="supplierPositions"
            :hide-default-footer="!supplier"
            disable-sort
            disable-pagination
          >
            <template v-slot:item.quantity="{ item }">
              <cart-part-quantity
                :item="item"
                class="count"
              />
            </template>
            <template v-slot:item.inStock="{ item }">
              <div class="available">
                {{ item.inStock }}
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="available__wrapper"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                      >
                        <path
                          d="M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Zm.6,9H7.4V7.4H8.6Zm0-4.8H7.4V5H8.6Z"
                          transform="translate(-2 -2)"
                          fill="#8a2a2b"
                        />
                      </svg>
                    </div>
                  </template>
                  <div class="cart__stock-tooltip">
                    {{ $t('views.cart.data_preliminary') }}
                  </div>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.price="{ item }">
              {{ item.price | numberFormatter }}
            </template>
            <template v-slot:item.sum="{ item }">
              {{ item.sum | numberFormatter }}
            </template>
            <template v-slot:item.sumWithVAT="{ item }">
              {{ item.sumWithVAT | numberFormatter }}
            </template>
            <template v-slot:item.delete="{ item }">
              <v-hover
                v-slot="{ hover }"
              >
                <v-icon
                  :class="hover ? '' : 'text--disabled'"
                  color="primary"
                  size="20"
                  @click="deletePosition(item.code)"
                >
                  mdi-delete
                </v-icon>
              </v-hover>
            </template>
            <template v-slot:footer.page-text>
              <div
                v-if="workMode.isModeSollers && supplier"
                class="d-flex align-items-center"
              >
                <div class="basket-page__info__wrapper mr-10">
                  <span class="basket-page__info__name">
                    <!--{{ $t('common.order_sum') }}:-->
                    Цена дилера (без НДС):
                    <span class="basket-page__info__value">
                      {{ subTotalBySupplier[supplier].total | numberFormatter }}
                      <span class="rouble">i</span>
                    </span>
                  </span>
                  <span class="basket-page__info__name">
                    {{ $t('common.total_vat') }}:
                    <span class="basket-page__info__value">
                      {{ subTotalBySupplier[supplier].totalVAT | numberFormatter }}
                      <span class="rouble">i</span>
                    </span>
                  </span>
                  <span class="basket-page__info__name">
                    <!--{{ $t('common.order_sum_with_vat') }}:-->
                    Сумма дилера (с НДС):
                    <span class="basket-page__info__value">
                      {{ subTotalBySupplier[supplier].totalWithVAT | numberFormatter }}
                      <span class="rouble">i</span>
                    </span>
                  </span>
                </div>
                <button
                  class="btn spdo-button spdo-button_line spdo-button_lowercase basket-page__dop-info__confirm ml-auto my-auto"
                  :disabled="loading"
                  @click="checkoutBySupplier(supplier)"
                >
                  {{ $t('views.cart.checkout') }}
                </button>
              </div>
            </template>
          </v-data-table>
        </div>

        <!-- Result sub total regular -->
        <cart-sub-total
          v-if="workMode.isModeSollers && !supplier"
          :key="supplier + 'total'"
          :limit-balance="subTotalBalanceRegular"
          :total="subTotalRegular"
        />
      </div>

      <!-- Result sub total final -->
      <cart-sub-total
        v-if="!workMode.isModeSollers || (subTotalFinal && subTotalFinal.total > 0)"
        :limit-balance="subTotalBalanceFinal"
        :total="subTotalFinal"
      />

      <v-form
        ref="form"
        @submit.prevent="checkout"
      >
        <v-row class="mt-5">
          <v-col cols="3">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('views.cart.dealer_internal_order') }}
              </label>
              <v-text-field
                v-model="order.dealerInternalOrder"
                solo
                type="text"
              />
            </div>
          </v-col>

          <v-col cols="3">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('views.cart.shipTo') }}
              </label>
              <v-select
                v-model="order.shipTo"
                :items="dealerPlants"
                item-text="asdb"
                item-value="asdb"
                hide-details
                solo
              >
                <template
                  v-slot:item="data"
                >
                  {{ data.item.name }} - {{ data.item.actualAddress }}
                </template>
              </v-select>
            </div>
          </v-col>

          <v-col
            v-if="!workMode.isModeSollers"
            cols="6"
          >
            <div class="input-block input-block_white">
              <label class="input-block__label input-block__label_info">
                VIN
                <span class="info-text">{{ $t('views.cart.vin_optional') }}</span>
              </label>
              <v-text-field
                v-model="order.VIN"
                solo
                type="text"
                :rules="[rules.requiredIfTypeVin]"
              />
            </div>
          </v-col>

          <v-col
            v-if="!workMode.isModeSollers"
            cols="3"
          >
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('common.order_type') }}
              </label>
              <v-select
                v-model="order.orderType"
                :items="orderTypes"
                solo
                class="select-block__select"
                :rules="[rules.required]"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="9">
            <div class="textarea-block textarea-block_white basket-page__dop-info__comment-place">
              <label
                for="comment-for-order"
                class="textarea-block__label"
              >
                {{ $t('common.comment') }}
              </label>
              <v-textarea
                id="comment-for-order"
                v-model="order.comments"
                rows="4"
                solo
                hide-details
                class="textarea-block__textarea"
              />
            </div>
          </v-col>

          <v-col
            cols="3"
            class="d-flex flex-column align-items-end justify-content-between"
          >
            <!-- eslint-disable max-len -->
            <button
              type="button"
              class="btn spdo-button spdo-button_line spdo-button_lowercase basket-page__dop-info__attach"
              :disabled="loading"
              @click="showLoadModal"
            >
              {{ $t('views.cart.load_from_file') }}
            </button>
            <button
              type="submit"
              class="btn spdo-button spdo-button_line spdo-button_lowercase basket-page__dop-info__confirm"
              :disabled="loading || !cart.length"
            >
              {{ $t('views.cart.checkout') }}
            </button>
            <!-- eslint-enable max-len -->
          </v-col>
        </v-row>
      </v-form>
    </main>
    <upload-cart
      v-model="isLoadModalShown"
      @hideModal="hideLoadModal"
    />
  </div>
</template>

<script>
import _round from 'lodash.round';
import { mapState } from 'vuex';
import { orderTypes } from '@/utils/enums';
import UploadCart from '@/components/orders/UploadCart';
import CartSubTotal from '@/components/orders/CartSubTotal';
import CartPartQuantity from '@/components/orders/CartPartQuantity';

export default {
  name: 'Cart',

  components: {
    UploadCart,
    CartSubTotal,
    CartPartQuantity,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t('common.part_code'),
          value: 'code',
        },
        {
          //text: this.$t('common.name'),
          text: 'Наименование',
          value: 'name',
        },
        {
          text: this.$t('common.quantity'),
          value: 'quantity',
        },
        {
          text: this.$t('views.cart.in_stock'),
          value: 'inStock',
        },
        {
          //text: this.$t('common.price'),
          text: 'РРЦ (без НДС) за 1 шт.',
          value: 'recommendedRetailPrice',
        },
        {
          //text: this.$t('common.discount'),
          text: 'Скидка дилера, %',
          value: 'discount',
        },
        {
          //text: this.$t('common.order_sum'),
          text: 'Цена дилера (без НДС) за все кол-во шт.',
          value: 'sum',
        },
        {
          //text: this.$t('common.order_sum_with_vat'),
          text: 'Сумма дилера (с НДС) за все кол-во шт.',
          value: 'sumWithVAT',
        },
        {
          text: this.$t('common.delete'),
          value: 'delete',
        },
      ],

      order: {
        orderType: '',
        dealerInternalOrder: '',
        comments: '',
        VIN: '',
        shipTo: '',
      },

      orderTypes,

      loading: false,
      dealerPlants: [],
      isLoadModalShown: false,

      rules: {
        required: (value) => Boolean(value) || this.$t('validation.required'),
        requiredIfTypeVin: (value) => (this.order.orderType === 'VIN' ? Boolean(value) : true)
          || this.$t('validation.required'),
        validateItemQuantity: (multiplicity, minVolume) => ((value) => {
          if (multiplicity > 1 && (value % multiplicity)) {
            return this.$t('validation.multiplicity', { multiplicity });
          }

          if (minVolume > 1 && (value < minVolume)) {
            return this.$t('validation.min_volume', { minVolume });
          }

          return true;
        }),
      },
    };
  },

  computed: {
    ...mapState(['user', 'dealer', 'cart', 'workMode']),

    subTotalRegular() {
      return (this.workMode.isModeSollers)
        ? this.calculateTotals(this.positionsBySupplier[''])
        : {};
    },

    subTotalFinal() {
      return (this.workMode.isModeSollers)
        ? this.calculateTotals(this.positions.filter((it) => it.supplier && it.supplier.code))
        : this.calculateTotals(this.positions);
    },

    subTotalBalanceRegular() {
      const { advanceBalance = {} } = this.dealer || {};

      return this.workMode.isModeSollers ? (advanceBalance.regular || 0) : 0;
    },
    subTotalBalanceFinal() {
      const { advanceBalance = {}, creditLimit = {} } = this.dealer || {};

      return (this.workMode.isModeSollers) ? (advanceBalance.crossDocking || 0) : (creditLimit.balance || 0);
    },
    positions() {
      return this.cart.map((position) => {
        const inStock = position.quantity <= position.currentBalance
          ? this.$t('views.cart.enough')
          : this.$t('views.cart.not_enough');
        const baseDiscount = position.baseDiscount || 0;
        const discountRow = (this.dealer.discounts || []).find(
          (row) => row.orderType === this.order.orderType,
        );
        const additionalDiscount = (discountRow && discountRow.discount) || 0;
        const discount = _round(baseDiscount - additionalDiscount, 2);
        const price = position.recommendedRetailPrice || 0;
        const sum = _round((price - ((price * discount) / 100)) * position.quantity, 2);
        const sumWithVAT = _round((sum + (sum * position.VATRate) / 100), 2);
        return {
          ...position,
          inStock,
          discount,
          sum,
          sumWithVAT,
          recommendedRetailPrice: this.$numberFormatter(position.recommendedRetailPrice)
        };
      });
    },
    positionsBySupplier() {
      const idx = this.positions.reduce((acc, it) => {
        const code = this.workMode.isModeSollers ? (it.supplier && it.supplier.code) || '' : '';

        if (!acc[code]) { acc[code] = []; }

        acc[code].push(it);
        return acc;
      },
      // We need init non-supplier property, in order to get it first in loop
      { '': [] });

      // But if it empty, then later delete it
      if (!idx[''].length) {
        delete idx[''];
      }

      return idx;
    },

    subTotalBySupplier() {
      const subTotalBySupplier = {};
      Array.from(Object.entries(this.positionsBySupplier)).forEach(([key, positions]) => {
        if (!key) {
          return;
        }
        subTotalBySupplier[key] = this.calculateTotals(positions);
      });
      return subTotalBySupplier;
    },

    kind() {
      return this.cart.length ? this.cart[0].kind : '';
    },
  },

  created() {
    this.setWorkModeLayout();
    this.getDealerPlants();
    this.updateDealerBalance();
    this.$store.commit('refreshCart');
  },

  methods: {
    calculateTotals(positions = []) {
      const total = _round(positions.reduce((acc, { sum }) => acc + sum, 0), 2);
      const totalWithVAT = _round(positions.reduce((acc, { sumWithVAT }) => acc + sumWithVAT, 0), 2);
      const totalVAT = _round(totalWithVAT - total, 2);

      return { total, totalWithVAT, totalVAT };
    },
    setWorkModeLayout() {
      if (this.workMode.isModeSollers) {
        this.headers.splice(this.headers.findIndex((item) => item.value === 'discount'), 1);
        this.order.orderType = 'VOR';
      }
    },

    deletePosition(code) {
      this.$store.commit('deletePosition', code);
    },

    showLoadModal() {
      this.isLoadModalShown = true;
    },

    hideLoadModal() {
      this.isLoadModalShown = false;
    },

    async updateDealerBalance() {
      this.loading = true;
      try {
        const params = { populate: 'creditLimit' };
        const { data: dealerData } = await this.$http.get(`dealers/${this.user.asdb}`, {
          params,
        });
        this.$store.commit('setDealer', dealerData);
      } finally {
        this.loading = false;
      }
    },

    async checkout() {
      if (!this.validate()) {
        return;
      }

      this.loading = true;
      try {
        const notOrderedParts = [];
        await Promise.all(
          Array.from(Object.keys(this.positionsBySupplier))
            .map((supplier) => this.$http.post('/orders', {
              ...this.order,
              kind: this.positionsBySupplier[supplier][0].kind,
              parts: this.positionsBySupplier[supplier].map(({ code, quantity }) => ({ code, quantity })),
            })
              .catch(() => {
                notOrderedParts.push(...this.positionsBySupplier[supplier]);
                const prefix = supplier || 'Regular';
                this.$toast(`${prefix}: ${this.$t('views.cart.order_not_created')}`, {
                  title: this.$t('toast.danger'),
                  variant: 'danger',
                });
              })),
        );
        await this.updateDealerBalance();
        this.$store.commit('replaceCart', notOrderedParts);
        if (!notOrderedParts.length) {
          this.$router.push('/orders');
        }
      } finally {
        this.loading = false;
      }
    },

    async checkoutBySupplier(supplier) {
      if (!this.validate()) {
        return;
      }

      await this.$http.post('/orders', {
        ...this.order,
        kind: this.positionsBySupplier[supplier][0].kind,
        parts: this.positionsBySupplier[supplier].map(({ code, quantity }) => ({ code, quantity })),
      });

      const cartBySupplier = JSON.parse(JSON.stringify(this.positionsBySupplier));

      delete cartBySupplier[supplier];
      const notOrderedParts = Object.values(cartBySupplier)
        .reduce((acc, item) => { acc.push(...item); return acc; }, []);

      this.$store.commit('replaceCart', notOrderedParts);
      if (!notOrderedParts.length) {
        this.$router.push('/orders');
      }
    },

    async getDealerPlants() {
      if (this.workMode.isModeSollers) {
        const { data } = await this.$http.get(`dealers/${this.asdb || this.user.asdb}/plants`);
        this.dealerPlants = data;
        if (data.length === 1) {
          this.order.shipTo = data[0].asdb;
        }
      }
    },

    validate() {
      this.$refs.form.validate();
      const required = ['orderType'];
      if (this.order.orderType === 'VIN') {
        required.push('VIN');
      }
      return required.every((field) => this.order[field]);
    },
  },
};
</script>

<style lang="scss">
.basket-page {
  &__supplier {
    display: block;
    margin-bottom: 14px;
    color: var(--topaz);
    font-size: 18px;
    line-height: 24px;
  }

  &__main {
    margin-bottom: 20px;

    .v-text-field--solo .v-input__slot {
      padding: 0 12px !important;
    }
  }

  &__dop-info {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(2, auto);
    column-gap: 40px;

    &__attach {
      padding: 10px 15px;
      white-space: nowrap;
      color: var(--aurum);
      width: 200px;
      margin-top: 26px;

      &:hover {
        color: var(--margaritas);
      }

      &:active {
        color: var(--aurum);
      }
    }

    &__confirm {
      padding: 10px 30px;
      white-space: nowrap;
      width: 200px;
    }

    &__comment-place {
      textarea {
        resize: none;
        margin-top: 0 !important;
      }
    }
  }

  &__wrapper {
    display: grid;
    row-gap: 20px;
    grid-template-rows: minmax(72px, 91px) 1fr;
    align-items: end;
  }

  &__inner {
    display: grid;
    align-items: end;
    grid-template-columns: 1fr auto;
    column-gap: 20px;
  }

  &__wrapper-input {
    display: grid;
    grid-template-columns: minmax(0, 270px) minmax(200px, 450px);
    column-gap: 20px;
  }

  .v-data-footer__select,
  .v-data-footer__icons-before,
  .v-data-footer__icons-after {
    display: none;
  }

  .v-data-footer {
    display: flex;
    justify-content: flex-end;
    padding: 8px;
    font-size: 1rem;

    &__pagination {
      margin: 0;
    }
  }
}

.count {
  display: grid;
  grid-template-columns: 60px min-content;
  column-gap: 10px;
  align-items: center;

  &__input {
    width: 60px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding: 0 10px;
    transition: border-color 0.3s ease-in-out;
    -moz-appearance: textfield;

    &:hover {
      border-color: var(--margaritas);
    }

    &:focus {
      outline: none;
      border-color: var(--aurum);
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__controls {
    display: grid;
    row-gap: 3px;

    svg {
      cursor: pointer;
      user-select: none;
      fill: var(--topaz);
      transition: opacity 0.3s ease-in-out;
      opacity: 1;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.available {
  display: grid;
  grid-template-columns: auto 12px;
  align-items: center;
  column-gap: 10px;

  svg {
    cursor: pointer;
  }

  &__popup {
    opacity: 0;
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 195px;
    padding: 10px;
    line-height: 20px;
    text-align: left;
    box-shadow: 0 5px 9px 0px #00000047;
    pointer-events: none;
    background-color: #fff;
    transform: translateY(10px);
    z-index: 1;
    transition: 0.3s ease-in-out;
    transition-property: opacity, transform;

    &__text {
      color: var(--ruby);
    }
  }

  &__wrapper {
    position: relative;

    &:hover {
      .available__popup {
        opacity: 1;
        pointer-events: initial;
        transform: translateY(0);
      }
    }
  }
}

.cart__stock-tooltip {
  width: 200px;
}
</style>
